import repository from './repsitory'

const resource = '/gameExpansion'

export default {
    get () {
        return repository.get(`${resource}`)
    },
    getById (id) {
        return repository.get(`${resource}/${id}`)
    },
    getByGame (gameId) {
        return repository.get(`${resource}/gameLine/${gameId}`)
    },
    addgameExpansion (data) {
        return repository.post(`${resource}`, data)
    },
    updategameExpansion (data, id) {
        return repository.put(`${resource}/${id}`, data)
    },
}
